import type { ComponentType } from 'react';
import { lazy } from 'react';

import type { AppNavigationProps } from '../AppNavigation/AppNavigation';

const LoadableResizableAppNavigationInner: ComponentType<AppNavigationProps> = lazy(async () => {
  const { ResizableAppNavigationInner } = await import(
    /* webpackChunkName: "4-feat-resizable-left-nav" */ './internals/ResizableAppNavigationInner'
  );

  return { default: ResizableAppNavigationInner };
});

export default LoadableResizableAppNavigationInner;
